import type { PartnerCockpitContactDetail } from '@houzy/schemas/partner-cockpit/offer-requests';

import type { OfferRequestContactShortcut } from '../../lib/trackingEvents';

const MS_PER_MINUTE = 60_000;

const CONTACT_SHORTCUTS: Record<PartnerCockpitContactDetail, OfferRequestContactShortcut> = {
    phone: 'Phone',
    email: 'Email',
};

// From `matchedAt`, which is when the lead was listed for the partner. The floor at zero absorbs a browser clock
// running behind the server.
export function minutesSinceListed(matchedAt: string, now: Date = new Date()): number {
    return Math.max(0, Math.round((now.getTime() - Date.parse(matchedAt)) / MS_PER_MINUTE));
}

export function contactShortcutOf(detail: PartnerCockpitContactDetail): OfferRequestContactShortcut {
    return CONTACT_SHORTCUTS[detail];
}
